import {
  Component,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  NavController,
  ToastController,
  LoadingController,
  AlertController,
  Slides,
  Content,
} from "ionic-angular";

import {
  Project,
  Master,
  UserMyRadiant as User,
  HelperMyRadiant,
} from "../../../providers/";
import {
  ListProjectPage,
  LoginPage,
  ProfilePage,
} from "../../project_mobile/index";
import {
  Nav,
  NavParams,
  MenuController,
  Events,
  ModalController,
} from "ionic-angular";

import { HomePage as home, DetailNewsPage, NewsPage } from "../index";
import { TabsPage } from "../tabs/tabs";
import {
  LoginMyRadiant as LoginProvider,
  RepositoryMyRadiant,
} from "../../../providers/";
import { LoginPageAproval } from "@pages/aproval_erp";
import { ListFormPageDynamic } from "@pages/dynamic_form";

@Component({
  selector: "page-dashboard",
  templateUrl: "page.html",
})
export class HomePage {
  @ViewChild("slider") private slider: Slides;
  @ViewChild("cmpMarquee") private marquee: ElementRef;
  @ViewChild(Content) content: Content;

  tab3Title = " ";
  btnTabNewsActive = "public";
  akses_modul = 0;
  loading: any;

  // Kumpulan State
  stateComponent: any = {
    slider: {
      loop: false,
    },
    skeletonBerita: true,
    toolbar_color: "",
  };

  // Kumpulan Data
  data: any = {
    runingText: "Selamat Datang di aplikasi MyRadiant",
    beritaSlide: [
      {
        date_news_created: "No content",
        title: "No content",
        image_url: "./assets/img/no_img.jpg",
      },
    ],
    beritaList: [],
    beritaAll: [],
    defaultLoading: "./assets/icon/loading.gif",
  };

  // Kumpulan parameter
  parameter: any = {
    runingText: {
      token: "dashboard-frontend",
      board: "announcement",
    },
    beritaSlide: {
      token: "dashboard-frontend",
      board: "public",
      controller: "SRV0120",
      // controller : 'SRV0094'
    },
    beritaList: {
      token: "dashboard-frontend",
      board: "announcement",
      controller: "SRV0040",
    },
  };

  akses = this.userApi.akses;

  form = {
    username: "",
    password: "",
  };
  statePrivate: any = false;
  myunit: any = {
    url : ''
  };

  now_datetime: any = ""

  constructor(
    public  navCtrl           : NavController,
    public  toastCtrl         : ToastController,
    public  loadingCtrl       : LoadingController,
    public  alertCtrl         : AlertController,
    public  masterApi         : Master,
    public  userApi           : User,
    public  menuCtrl          : MenuController,
    public  projectApi        : Project,
    public  modalCtrl         : ModalController,
    public  nav               : Nav,
    public  navParams         : NavParams,
    public  repositoryProvider: RepositoryMyRadiant,
    public  loginProvider     : LoginProvider,
    public  sanitizer         : DomSanitizer,
    private helper            : HelperMyRadiant,
    public  events            : Events,
    public  ref               : ChangeDetectorRef
  ) {
    this.getAkses();
    this.getBeritaSlide();
    this.getRuningText();
    this.eventsListeners();
    if (this.akses_modul > 0) {
      this.getMyUnitBoard();
    }
    let me = this;
    this.events.subscribe("user:sign_in", (resp) => {
      if (me.akses_modul > 0) {
        me.getMyUnitBoard();
      }
    });

    this.events.subscribe("user:has_set_fitur", () => {
      this.akses = this.userApi.akses;
      // console.log(this.akses);
    });

    // console.log("All News => ", this.data);

    var currentdate = new Date();
    this.now_datetime = currentdate.getFullYear() + "-"
      + (currentdate.getMonth() + 1) + "-"
      + currentdate.getDate() + " ";
    // console.log("Date Now => ", this.now_datetime);
  }
  ionViewDidEnter() {
    const rateCmp = Array.from(document.getElementsByTagName("img"));
    let me = this;
    rateCmp.forEach((cmp) => {
      cmp.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });
    document
      .getElementsByTagName("ion-app")[0]
      .setAttribute("id", "app-myradiant");
  }

  eventsListeners() {
    this.events.subscribe("home:load_news", (res) => {
      this.getBeritaSlide();
    });
  }

  doRefresh(refresher) {
    refresher.complete();
  }

  // defaultUrl(evt){
  //   return './assets/img/no_img.jpg';
  // }

  getAkses() {
    let is_loginProvider = this.userApi.is_login;
    if (localStorage.form_login != undefined) {
      // console.log("api_user", is_loginProvider);
      if (is_loginProvider == 0) {
        this.getDataLogin();
      }
      this.akses_modul = 2;
    } else {
      localStorage.clear();
      this.menuCtrl.enable(true, "MainMenu");
    }
  }

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: "Yakin akan keluar ?",
      buttons: [
        {
          text: "Tidak",
          handler: () => { },
        },
        {
          text: "Ya",
          handler: () => {
            this.logout();
          },
        },
      ],
    });
    confirm.present();
  }

  logout() {
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  toProfile() {
    this.navCtrl.push(ProfilePage);
  }

  addNews() {
    this.navCtrl.push(NewsPage);
  }

  getDataLogin() {
    this.showLoading();
    this.form = JSON.parse(localStorage.form_login);
    let params = this.form;

    this.userApi.login(params).subscribe(
      (resp: any) => {
        this.loading.dismiss();
        if (resp.success) {
          localStorage.is_login = 1;
          localStorage.form_login = JSON.stringify(this.form);
          localStorage.data_user = JSON.stringify(resp);
          this.loginProvider.setSession();
          this.events.publish("user:sign_in", resp);
          this.menuCtrl.enable(true, "MainMenu");
          this.userApi.hak_akses_modul = resp.modul_akses;
        } else {
          this.events.publish("user:want_sign_out");
        }
      },
      (err) => {
        this.presentToast("Error");
        localStorage.clear();
        this.loading.dismiss();
      }
    );
  }

  showLoading(msg = "Please wait...") {
    this.loading = this.loadingCtrl.create({
      content: msg,
    });
    this.loading.present();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top",
      })
      .present();
  }

  getRuningText(callback?: any) {
    let me = this;
    let params = this.parameter.runingText;
    this.repositoryProvider.getRuningText(params).subscribe(
      (resp: any) => {
        if (resp.success) {
          let data = resp.data;
          data.forEach((row) => {
            if (row.url == params.board) {
              me.data.runingText = this.sanitizer.bypassSecurityTrustHtml(
                row.running_text
              );
            }
          });
        }
        callback;
      },
      (err) => {
        callback;
        this.presentToast("Error");
      }
    );
  }

  getMyUnitBoard() {
    let me = this;
    let params = JSON.parse(localStorage.form_login);
    params.token = "board";
    this.repositoryProvider.getMyUnitBoard(params).subscribe(
      (resp: any) => {
        me.myunit = resp.group;
      },
      (err) => {
        this.presentToast("Error");
      }
    );
  }

  toAprovalErp() {
    this.nav.setRoot(LoginPageAproval);
    this.events.publish("modul:aproval_erp");
  }

  //to modul Survey
  toSurvey() {
    this.nav.setRoot(ListFormPageDynamic);
    this.events.publish("modul:form");
  }

  getBeritaSlide(isLoading?: any) {
    let me = this;
    let params = this.parameter.beritaSlide;
    params.employee_id = this.userApi.data.Employee_ID;
    // params.is_private = this.statePrivate == true ? 1 : 0;
    params.is_private = 0;
    params.is_mobile = 1;
    params.is_higlight = 1;
    this.stateComponent.skeletonBerita = true;
    this.stateComponent.slider.loop = false;
    me.data.beritaAll = [];
    this.repositoryProvider.getBerita(params).subscribe(
      (resp: any) => {
        if (resp.success) {
          me.data.beritaSlide = [];
          me.data.beritaList = [];
          let data = resp.data;
          data.forEach((row) => {
            if (this.helper.ifvalnull(row.widget_code, "").includes("slide")) {
              if (row.expired_date_highlight >= this.now_datetime || row.expired_date_highlight == null)
                me.data.beritaSlide.push(row);
            } else {
              me.data.beritaAll.push(row);
              if (this.statePrivate == "IS_PRIVATE") {
                if (row.type_news == this.statePrivate) {
                  me.data.beritaList.push(row);
                }
              } else {
                me.data.beritaList.push(row);
              }
            }
          });
          if (me.data.beritaSlide.length > 1) {
            this.stateComponent.slider.loop = true;
            try {
              this.slider.loop = true;
              this.slider.startAutoplay();
            } catch (error) { }
          } else if (me.data.beritaSlide.length == 0) {
            let dataKosong = {
              url_image_merge: "./assets/img/no_img.jpg",
              date_news_created: "",
              title: "",
            };
            me.data.beritaSlide.push(dataKosong);
          }
          if (isLoading) {
            this.loading.dismiss();
          }
          me.stateComponent.skeletonBerita = false;
          // // console.log(me.data.beritaSlide);
        }
      },
      (err) => {
        // console.log(err);
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) { }
      }
    );
  }

  filterTabsNews(evt, value) {
    // this.marquee.start();
    // this.showLoading("Loading Data....");
    this.btnTabNewsActive = value;
    this.parameter.runingText.board = value;
    this.parameter.beritaSlide.board = value;
    this.getRuningText(this.getBeritaSlide(false));
    this.slider.slideTo(0);
  }

  detailNews(data) {
    this.nav.push(DetailNewsPage, { berita: data });
  }

  ionViewDidLoad() {
    //this.content.enableJsScroll();
    this.content.ionScroll.subscribe((data) => {
      if (data.scrollTop > 50) {
        this.stateComponent.toolbar_color = "biruApp";
      } else {
        this.stateComponent.toolbar_color = "";
      }
      this.ref.detectChanges();
    });
  }

  changePrivate(ev) {
    let isPrivate = ev.checked;
    this.statePrivate = ev.checked;
    // this.getBeritaSlide();
    if (isPrivate) {
      if ("url" in this.myunit) {
        this.filterTabsNews({}, this.myunit.url);
      } else {
        if (
          (this.userApi.data.my_unit_news == "service" ||
            this.userApi.data.my_unit_news == "corporate" ||
            this.userApi.data.my_unit_news == "operation" ||
            this.userApi.data.my_unit_news == "branch" ||
            this.userApi.data.my_unit_news == "finance") &&
          ev.checked
        ) {
          this.filterTabsNews({}, this.userApi.data.my_unit_news);
        } else {
          this.filterTabsNews({}, "public");
        }
      }
    } else {
      this.filterTabsNews({}, "public");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/home/page.ts